import orderEdit from '@/mixins/order-edit'

/** Филиал, которому показываются и категории «только для CRM» */
const FILIAL_WITH_CRM_ONLY_CATEGORIES = 4

/**
 * Категории меню в оформлении заказа: список, текущая категория и её смена.
 * Категории выбираются в сайдбаре, а на компактном десктопе - ещё и над блюдами.
 */
export default {
  mixins: [orderEdit],
  computed: {
    currentCategory () {
      return this.orderState.currentCategory
    },
    categoriesList () {
      const categories = this.$store.state.categories.categoriesList
      if (this.$store.getters['branches/getGlobalFilialId'] === FILIAL_WITH_CRM_ONLY_CATEGORIES) {
        return categories
      }
      return categories ? categories.filter(category => !category.onlyCrm) : []
    },
    localCategory: {
      get () {
        return this.currentCategory
      },
      set (value) {
        // Очистка строки поиска
        this.$store.commit(this.orderEditPrefix + '/setSearchMenu', '')
        this.$store.commit(this.orderEditPrefix + '/setCurrentCategory', value)
      },
    },
  },
  methods: {
    changeCategory (id) {
      this.$store.commit(this.orderEditPrefix + '/setCurrentOtherWindow', undefined)
      this.$store.commit(this.orderEditPrefix + '/setFoodWindowState', false)
      this.$store.commit(this.orderEditPrefix + '/setMenuItemsLoading', true)
      this.$store.commit(this.orderEditPrefix + '/togglePromotionsWindow', false)

      const meta = {
        sortField: 'name',
        sortMethod: 'asc',
      }

      this.$store
        .dispatch('categories/fetchFilialMenuSingleCategories', { id, meta })
        .then((res) => {
          if (res.status === 200) {
            this.$store.commit(
              this.orderEditPrefix + '/setMenuItemsList',
              res.data.data.menuItems,
            )
            this.$store.commit(
              this.orderEditPrefix + '/setCollectionsList',
              res.data.data.collections,
            )
          }
          this.$store.commit(this.orderEditPrefix + '/setCurrentCollectionId', undefined)
          this.$store.commit(this.orderEditPrefix + '/setMenuItemsLoading', false)
        })
    },
  },
}
